import { render, staticRenderFns } from "./OfficeField.vue?vue&type=template&id=4be0fec8&scoped=true"
import script from "./OfficeField.vue?vue&type=script&lang=js"
export * from "./OfficeField.vue?vue&type=script&lang=js"
import style0 from "./OfficeField.vue?vue&type=style&index=0&id=4be0fec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0fec8",
  null
  
)

export default component.exports